// JsFromRoutes CacheKey 6481707fbacd90897fbd19765af16d33
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  hsa: /* #__PURE__ */ definePathHelper('get', '/members/dashboard/hsa'),
  ichra: /* #__PURE__ */ definePathHelper('get', '/members/dashboard/ichra'),
  resolution: /* #__PURE__ */ definePathHelper('get', '/members/dashboard/resolution'),
}
